// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PlatformLink-module__font-s-10___QrW23 {
  font-size: 10px !important;
}

.PlatformLink-module__font-s-12___LCdXF {
  font-size: 12px !important;
}

.PlatformLink-module__font-s-13___imJ_N {
  font-size: 13px !important;
}

.PlatformLink-module__font-s-14___k_guY {
  font-size: 14px !important;
}

.PlatformLink-module__font-s-15___Z_f7V {
  font-size: 15px !important;
}

.PlatformLink-module__font-s-16___KacTr {
  font-size: 16px !important;
}

.PlatformLink-module__font-s-18___RvqYk {
  font-size: 18px !important;
}

.PlatformLink-module__font-s-20___ixzlj {
  font-size: 20px !important;
}

.PlatformLink-module__font-s-22___EwLpC {
  font-size: 22px !important;
}

.PlatformLink-module__font-s-28___QimVB {
  font-size: 28px !important;
}

.PlatformLink-module__font-w-400___jS4wt {
  font-weight: 400 !important;
}

.PlatformLink-module__font-w-500___DirbJ {
  font-weight: 500 !important;
}

.PlatformLink-module__font-w-600___q3_lX {
  font-weight: 600 !important;
}

.PlatformLink-module__font-w-700____k8V7 {
  font-weight: 700 !important;
}

.PlatformLink-module__p-5___AqpwV {
  padding: 5px !important;
}

.PlatformLink-module__p-12___xA8Pf {
  padding: 12px !important;
}

.PlatformLink-module__p-16___WDWtZ {
  padding: 16px !important;
}

.PlatformLink-module__p-30___Fux44 {
  padding: 30px !important;
}

.PlatformLink-module__p-b-0___rzKVW {
  padding-bottom: 0 !important;
}

.PlatformLink-module__p-b-5___vfSUJ {
  padding-bottom: 5px !important;
}

.PlatformLink-module__p-b-10___QWYIf {
  padding-bottom: 10px !important;
}

.PlatformLink-module__p-b-12___JBrhm {
  padding-bottom: 12px !important;
}

.PlatformLink-module__p-b-16___kxGWG {
  padding-bottom: 16px !important;
}

.PlatformLink-module__p-b-18___aN7lr {
  padding-bottom: 18px !important;
}

.PlatformLink-module__p-b-20___DyWLb {
  padding-bottom: 20px !important;
}

.PlatformLink-module__p-b-25___Hei_C {
  padding-bottom: 25px !important;
}

.PlatformLink-module__p-b-30___UMYAJ {
  padding-bottom: 30px !important;
}

.PlatformLink-module__p-b-50___LIemh {
  padding-bottom: 50px !important;
}

.PlatformLink-module__p-t-0___JVn7i {
  padding-top: 0 !important;
}

.PlatformLink-module__p-t-12___sAmA4 {
  padding-top: 12px !important;
}

.PlatformLink-module__p-t-16___T2GKH {
  padding-top: 16px !important;
}

.PlatformLink-module__p-t-18___Yo86a {
  padding-top: 18px !important;
}

.PlatformLink-module__p-t-20____lfR_ {
  padding-top: 20px !important;
}

.PlatformLink-module__p-t-30___mObUM {
  padding-top: 30px !important;
}

.PlatformLink-module__p-t-40___noYrH {
  padding-top: 40px !important;
}

.PlatformLink-module__p-t-50___Uoi5K {
  padding-top: 50px !important;
}

.PlatformLink-module__p-l-20___xne6W {
  padding-left: 20px !important;
}

.PlatformLink-module__p-l-30___tEEwb {
  padding-left: 30px !important;
}

.PlatformLink-module__p-l-40___TyvMl {
  padding-left: 40px !important;
}

.PlatformLink-module__p-r-16___ibtFn {
  padding-right: 16px !important;
}

.PlatformLink-module__p-r-20___AG872 {
  padding-right: 20px !important;
}

.PlatformLink-module__p-r-30___nCeDu {
  padding-right: 30px !important;
}

.PlatformLink-module__p-r-50___W3YX0 {
  padding-right: 50px !important;
}

.PlatformLink-module__p-r-60___Y082x {
  padding-right: 60px !important;
}

.PlatformLink-module__m-b-1___dHFRI {
  margin-bottom: 1px !important;
}

.PlatformLink-module__m-b-2___X0hY5 {
  margin-bottom: 2px !important;
}

.PlatformLink-module__m-b-6___OHEbx {
  margin-bottom: 6px !important;
}

.PlatformLink-module__m-b-8___uiy6P {
  margin-bottom: 8px !important;
}

.PlatformLink-module__m-b-10___FOC1p {
  margin-bottom: 10px !important;
}

.PlatformLink-module__m-b-14___zMaje {
  margin-bottom: 14px !important;
}

.PlatformLink-module__m-b-16___OPYt5 {
  margin-bottom: 16px !important;
}

.PlatformLink-module__m-b-20___HwXIC {
  margin-bottom: 20px !important;
}

.PlatformLink-module__m-b-22___Kpl40 {
  margin-bottom: 22px !important;
}

.PlatformLink-module__m-b-24___qwk9J {
  margin-bottom: 24px !important;
}

.PlatformLink-module__m-b-30___sl_fP {
  margin-bottom: 30px !important;
}

.PlatformLink-module__m-b-32___H7Cmn {
  margin-bottom: 32px !important;
}

.PlatformLink-module__m-b-40___ZXgiG {
  margin-bottom: 40px !important;
}

.PlatformLink-module__m-t-2___wfGFu {
  margin-top: 2px !important;
}

.PlatformLink-module__m-t-3___xxQcI {
  margin-top: 3px !important;
}

.PlatformLink-module__m-t-4___JYC99 {
  margin-top: 4px !important;
}

.PlatformLink-module__m-t-5___KKU2n {
  margin-top: 5px !important;
}

.PlatformLink-module__m-t-8___ryuft {
  margin-top: 8px !important;
}

.PlatformLink-module__m-t-10___U_3pv {
  margin-top: 10px !important;
}

.PlatformLink-module__m-t-15___KIqDN {
  margin-top: 15px !important;
}

.PlatformLink-module__m-t-16___xq0aU {
  margin-top: 16px !important;
}

.PlatformLink-module__m-t-20___MkewN {
  margin-top: 20px !important;
}

.PlatformLink-module__m-t-22___xUfFr {
  margin-top: 22px !important;
}

.PlatformLink-module__m-t-30___fGJFv {
  margin-top: 30px !important;
}

.PlatformLink-module__m-t-32___fP9i7 {
  margin-top: 32px !important;
}

.PlatformLink-module__m-l-auto___JRQeP {
  margin-left: auto !important;
}

.PlatformLink-module__m-l-4___SsLok {
  margin-left: 4px !important;
}

.PlatformLink-module__m-l-5___CcH0Q {
  margin-left: 5px !important;
}

.PlatformLink-module__m-l-6___dHbH9 {
  margin-left: 6px !important;
}

.PlatformLink-module__m-l-8___ERO1C {
  margin-left: 8px !important;
}

.PlatformLink-module__m-l-10___w8RNe {
  margin-left: 10px !important;
}

.PlatformLink-module__m-l-16___Dsh6c {
  margin-left: 16px !important;
}

.PlatformLink-module__m-l-20___RybaJ {
  margin-left: 20px !important;
}

.PlatformLink-module__m-l-24___sWBQO {
  margin-left: 24px !important;
}

.PlatformLink-module__m-l-30___DXQ2o {
  margin-left: 30px !important;
}

.PlatformLink-module__m-l-35___cgPB6 {
  margin-left: 35px !important;
}

.PlatformLink-module__m-l-40___FjwZW {
  margin-left: 40px !important;
}

.PlatformLink-module__m-r-8___pw_J_ {
  margin-right: 8px !important;
}

.PlatformLink-module__m-r-10___A0EUM {
  margin-right: 10px !important;
}

.PlatformLink-module__m-r-16___xA8bA {
  margin-right: 16px !important;
}

.PlatformLink-module__m-r-20___TubHj {
  margin-right: 20px !important;
}

.PlatformLink-module__m-r-24___qSkXd {
  margin-right: 24px !important;
}

.PlatformLink-module__m-r-30___uD7eH {
  margin-right: 30px !important;
}

.PlatformLink-module__m-r-40___enZQH {
  margin-right: 40px !important;
}

.PlatformLink-module__border-r-3___BP8lw {
  border-radius: 3px !important;
}

.PlatformLink-module__border-r-4___RSgxI {
  border-radius: 4px !important;
}

.PlatformLink-module__border-r-6___GDTHF {
  border-radius: 6px !important;
}

.PlatformLink-module__border-r-10___cDCDG {
  border-radius: 10px !important;
}

.PlatformLink-module__border-r-12___UB3zK {
  border-radius: 12px !important;
}

.PlatformLink-module__border-r-16___cl1R7 {
  border-radius: 16px !important;
}

.PlatformLink-module__border-r-50___wzLtm {
  border-radius: 50% !important;
}

.PlatformLink-module__primary-border___dJ1Mq {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.PlatformLink-module__primary-border-b___dOCHH {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.PlatformLink-module__primary-border-t___W27Ga {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.PlatformLink-module__primary-border-l___NcDDx {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.PlatformLink-module__primary-border-r___etbnD {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.PlatformLink-module__secondary-border___B8Rje {
  border: 1px solid #637768;
}

.PlatformLink-module__secondary-border-b___pr65Z {
  border-bottom: 1px solid #637768;
}

.PlatformLink-module__secondary-border-t___lBfZk {
  border-top: 1px solid #637768;
}

.PlatformLink-module__secondary-border-l___zYbU4 {
  border-left: 1px solid #637768;
}

.PlatformLink-module__secondary-border-r___SKbo1 {
  border-right: 1px solid #637768;
}

.PlatformLink-module__gap-0___r3kLP {
  gap: 0 !important;
}

.PlatformLink-module__gap-2____dEB7 {
  gap: 2px !important;
}

.PlatformLink-module__gap-4___uK2eP {
  gap: 4px !important;
}

.PlatformLink-module__gap-5___iyAyn {
  gap: 5px !important;
}

.PlatformLink-module__gap-6___hKtk7 {
  gap: 6px !important;
}

.PlatformLink-module__gap-8___EEMMT {
  gap: 8px !important;
}

.PlatformLink-module__gap-10___A2YnI {
  gap: 10px !important;
}

.PlatformLink-module__gap-12___rTc5D {
  gap: 12px !important;
}

.PlatformLink-module__gap-14___VAJys {
  gap: 14px !important;
}

.PlatformLink-module__gap-16____zNIE {
  gap: 16px !important;
}

.PlatformLink-module__gap-18___s5Al1 {
  gap: 18px !important;
}

.PlatformLink-module__gap-20___TqP9U {
  gap: 20px !important;
}

.PlatformLink-module__gap-24___o0R8K {
  gap: 24px !important;
}

.PlatformLink-module__gap-26___jkBVA {
  gap: 26px !important;
}

.PlatformLink-module__gap-30___iL9Bx {
  gap: 30px !important;
}

.PlatformLink-module__gap-32___H6fCf {
  gap: 32px !important;
}

.PlatformLink-module__gap-40___vbeR1 {
  gap: 40px !important;
}

.PlatformLink-module__gap-50___NTkFz {
  gap: 50px !important;
}

.PlatformLink-module__flex-1___T6wOv {
  flex: 1;
}

.PlatformLink-module__flex-none___NFG8C {
  flex: none !important;
}

.PlatformLink-module__flex-column___pgbSa {
  display: flex;
  flex-direction: column !important;
}

.PlatformLink-module__flex-row___GGKRy {
  display: flex;
  flex-direction: row !important;
}

.PlatformLink-module__vertically-centered___TL1d4 {
  display: flex;
  align-items: center !important;
}

.PlatformLink-module__horizontally-centered___QiS26 {
  display: flex;
  justify-content: center !important;
}

.PlatformLink-module__horizontally-end___woCgS {
  display: flex;
  justify-content: end !important;
}

.PlatformLink-module__vertically-start___danm5 {
  display: flex;
  align-items: start !important;
}

.PlatformLink-module__space-between___MgOl3 {
  display: flex;
  justify-content: space-between !important;
}

.PlatformLink-module__flex-wrap___QdYoe {
  flex-wrap: wrap !important;
}

.PlatformLink-module__height-100___m3eE_ {
  height: 100%;
}

.PlatformLink-module__width-50___MZSgp {
  width: 50% !important;
}

.PlatformLink-module__width-100___In11X {
  width: 100%;
}

.PlatformLink-module__cursor-pointer___ScqGE {
  cursor: pointer;
}

.PlatformLink-module__cursor-not-allowed___wZMU_ {
  cursor: not-allowed !important;
}

.PlatformLink-module__absolute-centered___yYi75 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.PlatformLink-module__absolute___Ju20U {
  position: absolute;
}

.PlatformLink-module__relative___c1rtO {
  position: relative;
}

.PlatformLink-module__fixed___doNzB {
  position: fixed;
}

.PlatformLink-module__visible___JT_uu {
  opacity: 1;
}

.PlatformLink-module__invisible___CrYc9 {
  opacity: 0;
}

.PlatformLink-module__col-90___MwByH {
  width: 90% !important;
}

.PlatformLink-module__col-auto___vjqwC {
  width: auto !important;
}

.PlatformLink-module__medical-tabs___SoYNH {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.PlatformLink-module__medical-table-new___Qu7UE {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.PlatformLink-module__medical-table-new___Qu7UE:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.PlatformLink-module__medical-table-new___Qu7UE::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.PlatformLink-module__medical-table-new___Qu7UE::-webkit-scrollbar-track {
  display: none;
}
.PlatformLink-module__medical-table-new___Qu7UE.PlatformLink-module__no-pagination___xdqwd {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.PlatformLink-module__medical-table-new___Qu7UE.PlatformLink-module__no-pagination___xdqwd:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.PlatformLink-module__medical-table-new___Qu7UE.PlatformLink-module__no-pagination___xdqwd::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.PlatformLink-module__medical-table-new___Qu7UE.PlatformLink-module__no-pagination___xdqwd::-webkit-scrollbar-track {
  display: none;
}

.PlatformLink-module__medical-table-empty___HmIQw {
  padding: 14px 40px !important;
}

.PlatformLink-module__icon-btn___lguC2 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.PlatformLink-module__search-icon___TIWXV {
  width: 24px;
  height: 24px;
  align-self: center;
}

.PlatformLink-module__disable-select___XsiTi {
  user-select: none;
}

.PlatformLink-module__break-word___Ybyqt {
  word-break: break-word;
}

.PlatformLink-module__popup-clear-btn___p1jz8 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.PlatformLink-module__scroll-m-b-20___xuAEZ {
  scroll-margin-bottom: 20px;
}

.PlatformLink-module__link___Q41xQ {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 10px;
  width: 100%;
  background: #fafafa;
  border: 1px solid #e4e4e7;
  border-radius: 6px;
  text-decoration: none;
  color: #18181b;
  cursor: pointer;
  transition: border-color 0.15s, color 0.15s, background-color 0.15s;
  text-align: left;
}

.PlatformLink-module__link___Q41xQ:hover {
  border-color: #a1a1aa;
}

.PlatformLink-module__link___Q41xQ:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 2px;
}

.PlatformLink-module__disabled___jaSiv {
  cursor: default;
  opacity: 0.7;
}

.PlatformLink-module__disabled___jaSiv:hover {
  border-color: #e4e4e7;
}

.PlatformLink-module__badge___bunC1 {
  width: 22px;
  height: 22px;
  border-radius: 4px;
  background: #18181b;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.PlatformLink-module__badgeText___t_p7S {
  font-size: 10px;
  font-weight: 700;
  color: #fafafa;
  font-family: "IBM Plex Mono", monospace;
}

.PlatformLink-module__meta___elKaF {
  flex: 1;
}

.PlatformLink-module__title___Qwkvu {
  font-size: 11px;
  font-weight: 600;
}

.PlatformLink-module__mrn___kUZux {
  font-size: 10px;
  color: #a1a1aa;
  margin-left: 6px;
  font-family: "IBM Plex Mono", monospace;
}

.PlatformLink-module__arrow___lN9gq {
  font-size: 13px;
  color: #a1a1aa;
}

.PlatformLink-module__line___M5lU3 {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border: 1px solid transparent;
  border-radius: 6px;
  background: transparent;
  font: inherit;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  color: #18181b;
  text-decoration: underline;
  text-decoration-color: #d4d4d8;
  text-underline-offset: 3px;
  cursor: pointer;
  transition: background-color 0.15s, border-color 0.15s;
}
.PlatformLink-module__line___M5lU3:hover:not(:disabled) {
  border-color: #d4d4d8;
  background: #ffffff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  text-decoration: none;
}
.PlatformLink-module__line___M5lU3 {
  outline: none;
}
.PlatformLink-module__line___M5lU3:focus-visible {
  outline: 2px solid #18181b;
  outline-offset: 1px;
}
.PlatformLink-module__line___M5lU3:disabled, .PlatformLink-module__line___M5lU3[aria-disabled=true] {
  color: #a1a1aa;
  cursor: default;
}

.PlatformLink-module__menuItem___NXTFo {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 12px;
  text-align: left;
}

.PlatformLink-module__menuItemLabel___hf5_m {
  font-size: 14px;
  font-weight: 500;
  color: #18181b;
}

.PlatformLink-module__menuItemHint___CpSKY {
  font-size: 12px;
  color: #a1a1aa;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/CareOrchestration/components/PlatformLink/PlatformLink.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_visit.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,mEAAA;EACA,gBAAA;AA8pBF;;AA3pBA;EACE,qBAAA;AA8pBF;;AA3pBA;EACE,0BAAA;EACA,mBAAA;AA8pBF;;AA3pBA;EACE,eAAA;EACA,YAAA;AA8pBF;;AA3pBA;EACE,qBAAA;AA8pBF;;AA3pBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AA8pBF;;AA3pBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,uCAAA;AA8pBF;;AA3pBA;EACE,OAAA;AA8pBF;;AA3pBA;EACE,eAAA;EACA,gBAAA;AA8pBF;;AA3pBA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,uCAAA;AA8pBF;;AA3pBA;EACE,eAAA;EACA,cAAA;AA8pBF;;AA3pBA;EE3BE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,uBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,eAAA;EACA,sDAAA;AF0rBF;AExrBE;EACE,qBAAA;EACA,mBAAA;EACA,yCAAA;EACA,qBAAA;AF0rBJ;AArrBA;EEpCE,aAAA;AF4tBF;AE1tBE;EACE,0BAAA;EACA,mBALuB;AFiuB3B;AE5rBE;EAEE,cAAA;EACA,eAAA;AF6rBJ;;AA5rBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,iBAAA;EACA,gBAAA;AA+rBF;;AA5rBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA+rBF;;AA5rBA;EACE,eAAA;EACA,cAAA;AA+rBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.link {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 10px;\n  width: 100%;\n  background: #fafafa;\n  border: 1px solid #e4e4e7;\n  border-radius: 6px;\n  text-decoration: none;\n  color: #18181b;\n  cursor: pointer;\n  transition: border-color 0.15s, color 0.15s, background-color 0.15s;\n  text-align: left;\n}\n\n.link:hover {\n  border-color: #a1a1aa;\n}\n\n.link:focus-visible {\n  outline: 2px solid #18181b;\n  outline-offset: 2px;\n}\n\n.disabled {\n  cursor: default;\n  opacity: 0.7;\n}\n\n.disabled:hover {\n  border-color: #e4e4e7;\n}\n\n.badge {\n  width: 22px;\n  height: 22px;\n  border-radius: 4px;\n  background: #18181b;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.badgeText {\n  font-size: 10px;\n  font-weight: 700;\n  color: #fafafa;\n  font-family: 'IBM Plex Mono', monospace;\n}\n\n.meta {\n  flex: 1;\n}\n\n.title {\n  font-size: 11px;\n  font-weight: 600;\n}\n\n.mrn {\n  font-size: 10px;\n  color: #a1a1aa;\n  margin-left: 6px;\n  font-family: 'IBM Plex Mono', monospace;\n}\n\n.arrow {\n  font-size: 13px;\n  color: #a1a1aa;\n}\n\n.line {\n  @include line-button;\n}\n\n.menuItem {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 8px 12px;\n  text-align: left;\n}\n\n.menuItemLabel {\n  font-size: 14px;\n  font-weight: 500;\n  color: #18181b;\n}\n\n.menuItemHint {\n  font-size: 12px;\n  color: #a1a1aa;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","$ready: #50ae3d;\n$ready-strong: #48813b;\n$ready-shadow: 0 1px 2px 0 rgba($ready, 0.1), 0 4px 12px -4px rgba($ready, 0.28);\n$ready-shadow-hover: 0 1px 2px 0 rgba($ready, 0.12), 0 6px 16px -4px rgba($ready, 0.34);\n\n$hairline: #e4e4e7;\n$rule: #f4f4f5;\n$label: #71717a;\n$focus: #18181b;\n$tracking-caps: 0.08em;\n\n$visit-kinds: (\n  followUp: (\n    base: #69945f,\n    strong: #48813b,\n  ),\n  consultation: (\n    base: #6687bd,\n    strong: #4972b7,\n  ),\n  infusion: (\n    base: #8e7ab5,\n    strong: #8065b1,\n  ),\n  assessment: (\n    base: #3c9888,\n    strong: #088272,\n  ),\n  carePlan: (\n    base: #3c93ac,\n    strong: #0b7d97,\n  ),\n  other: (\n    base: #7e8791,\n    strong: #6b747e,\n  ),\n);\n\n@mixin focus-ring($offset: 1px) {\n  outline: none;\n\n  &:focus-visible {\n    outline: 2px solid $focus;\n    outline-offset: $offset;\n  }\n}\n\n@mixin line-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 2px 8px;\n  border: 1px solid transparent;\n  border-radius: 6px;\n  background: transparent;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n  color: #18181b;\n  text-decoration: underline;\n  text-decoration-color: #d4d4d8;\n  text-underline-offset: 3px;\n  cursor: pointer;\n  transition: background-color 0.15s, border-color 0.15s;\n\n  &:hover:not(:disabled) {\n    border-color: #d4d4d8;\n    background: #ffffff;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n    text-decoration: none;\n  }\n\n  @include focus-ring;\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    color: #a1a1aa;\n    cursor: default;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `PlatformLink-module__font-s-10___QrW23`,
	"fontS12": `PlatformLink-module__font-s-12___LCdXF`,
	"fontS13": `PlatformLink-module__font-s-13___imJ_N`,
	"fontS14": `PlatformLink-module__font-s-14___k_guY`,
	"fontS15": `PlatformLink-module__font-s-15___Z_f7V`,
	"fontS16": `PlatformLink-module__font-s-16___KacTr`,
	"fontS18": `PlatformLink-module__font-s-18___RvqYk`,
	"fontS20": `PlatformLink-module__font-s-20___ixzlj`,
	"fontS22": `PlatformLink-module__font-s-22___EwLpC`,
	"fontS28": `PlatformLink-module__font-s-28___QimVB`,
	"fontW400": `PlatformLink-module__font-w-400___jS4wt`,
	"fontW500": `PlatformLink-module__font-w-500___DirbJ`,
	"fontW600": `PlatformLink-module__font-w-600___q3_lX`,
	"fontW700": `PlatformLink-module__font-w-700____k8V7`,
	"p5": `PlatformLink-module__p-5___AqpwV`,
	"p12": `PlatformLink-module__p-12___xA8Pf`,
	"p16": `PlatformLink-module__p-16___WDWtZ`,
	"p30": `PlatformLink-module__p-30___Fux44`,
	"pB0": `PlatformLink-module__p-b-0___rzKVW`,
	"pB5": `PlatformLink-module__p-b-5___vfSUJ`,
	"pB10": `PlatformLink-module__p-b-10___QWYIf`,
	"pB12": `PlatformLink-module__p-b-12___JBrhm`,
	"pB16": `PlatformLink-module__p-b-16___kxGWG`,
	"pB18": `PlatformLink-module__p-b-18___aN7lr`,
	"pB20": `PlatformLink-module__p-b-20___DyWLb`,
	"pB25": `PlatformLink-module__p-b-25___Hei_C`,
	"pB30": `PlatformLink-module__p-b-30___UMYAJ`,
	"pB50": `PlatformLink-module__p-b-50___LIemh`,
	"pT0": `PlatformLink-module__p-t-0___JVn7i`,
	"pT12": `PlatformLink-module__p-t-12___sAmA4`,
	"pT16": `PlatformLink-module__p-t-16___T2GKH`,
	"pT18": `PlatformLink-module__p-t-18___Yo86a`,
	"pT20": `PlatformLink-module__p-t-20____lfR_`,
	"pT30": `PlatformLink-module__p-t-30___mObUM`,
	"pT40": `PlatformLink-module__p-t-40___noYrH`,
	"pT50": `PlatformLink-module__p-t-50___Uoi5K`,
	"pL20": `PlatformLink-module__p-l-20___xne6W`,
	"pL30": `PlatformLink-module__p-l-30___tEEwb`,
	"pL40": `PlatformLink-module__p-l-40___TyvMl`,
	"pR16": `PlatformLink-module__p-r-16___ibtFn`,
	"pR20": `PlatformLink-module__p-r-20___AG872`,
	"pR30": `PlatformLink-module__p-r-30___nCeDu`,
	"pR50": `PlatformLink-module__p-r-50___W3YX0`,
	"pR60": `PlatformLink-module__p-r-60___Y082x`,
	"mB1": `PlatformLink-module__m-b-1___dHFRI`,
	"mB2": `PlatformLink-module__m-b-2___X0hY5`,
	"mB6": `PlatformLink-module__m-b-6___OHEbx`,
	"mB8": `PlatformLink-module__m-b-8___uiy6P`,
	"mB10": `PlatformLink-module__m-b-10___FOC1p`,
	"mB14": `PlatformLink-module__m-b-14___zMaje`,
	"mB16": `PlatformLink-module__m-b-16___OPYt5`,
	"mB20": `PlatformLink-module__m-b-20___HwXIC`,
	"mB22": `PlatformLink-module__m-b-22___Kpl40`,
	"mB24": `PlatformLink-module__m-b-24___qwk9J`,
	"mB30": `PlatformLink-module__m-b-30___sl_fP`,
	"mB32": `PlatformLink-module__m-b-32___H7Cmn`,
	"mB40": `PlatformLink-module__m-b-40___ZXgiG`,
	"mT2": `PlatformLink-module__m-t-2___wfGFu`,
	"mT3": `PlatformLink-module__m-t-3___xxQcI`,
	"mT4": `PlatformLink-module__m-t-4___JYC99`,
	"mT5": `PlatformLink-module__m-t-5___KKU2n`,
	"mT8": `PlatformLink-module__m-t-8___ryuft`,
	"mT10": `PlatformLink-module__m-t-10___U_3pv`,
	"mT15": `PlatformLink-module__m-t-15___KIqDN`,
	"mT16": `PlatformLink-module__m-t-16___xq0aU`,
	"mT20": `PlatformLink-module__m-t-20___MkewN`,
	"mT22": `PlatformLink-module__m-t-22___xUfFr`,
	"mT30": `PlatformLink-module__m-t-30___fGJFv`,
	"mT32": `PlatformLink-module__m-t-32___fP9i7`,
	"mLAuto": `PlatformLink-module__m-l-auto___JRQeP`,
	"mL4": `PlatformLink-module__m-l-4___SsLok`,
	"mL5": `PlatformLink-module__m-l-5___CcH0Q`,
	"mL6": `PlatformLink-module__m-l-6___dHbH9`,
	"mL8": `PlatformLink-module__m-l-8___ERO1C`,
	"mL10": `PlatformLink-module__m-l-10___w8RNe`,
	"mL16": `PlatformLink-module__m-l-16___Dsh6c`,
	"mL20": `PlatformLink-module__m-l-20___RybaJ`,
	"mL24": `PlatformLink-module__m-l-24___sWBQO`,
	"mL30": `PlatformLink-module__m-l-30___DXQ2o`,
	"mL35": `PlatformLink-module__m-l-35___cgPB6`,
	"mL40": `PlatformLink-module__m-l-40___FjwZW`,
	"mR8": `PlatformLink-module__m-r-8___pw_J_`,
	"mR10": `PlatformLink-module__m-r-10___A0EUM`,
	"mR16": `PlatformLink-module__m-r-16___xA8bA`,
	"mR20": `PlatformLink-module__m-r-20___TubHj`,
	"mR24": `PlatformLink-module__m-r-24___qSkXd`,
	"mR30": `PlatformLink-module__m-r-30___uD7eH`,
	"mR40": `PlatformLink-module__m-r-40___enZQH`,
	"borderR3": `PlatformLink-module__border-r-3___BP8lw`,
	"borderR4": `PlatformLink-module__border-r-4___RSgxI`,
	"borderR6": `PlatformLink-module__border-r-6___GDTHF`,
	"borderR10": `PlatformLink-module__border-r-10___cDCDG`,
	"borderR12": `PlatformLink-module__border-r-12___UB3zK`,
	"borderR16": `PlatformLink-module__border-r-16___cl1R7`,
	"borderR50": `PlatformLink-module__border-r-50___wzLtm`,
	"primaryBorder": `PlatformLink-module__primary-border___dJ1Mq`,
	"primaryBorderB": `PlatformLink-module__primary-border-b___dOCHH`,
	"primaryBorderT": `PlatformLink-module__primary-border-t___W27Ga`,
	"primaryBorderL": `PlatformLink-module__primary-border-l___NcDDx`,
	"primaryBorderR": `PlatformLink-module__primary-border-r___etbnD`,
	"secondaryBorder": `PlatformLink-module__secondary-border___B8Rje`,
	"secondaryBorderB": `PlatformLink-module__secondary-border-b___pr65Z`,
	"secondaryBorderT": `PlatformLink-module__secondary-border-t___lBfZk`,
	"secondaryBorderL": `PlatformLink-module__secondary-border-l___zYbU4`,
	"secondaryBorderR": `PlatformLink-module__secondary-border-r___SKbo1`,
	"gap0": `PlatformLink-module__gap-0___r3kLP`,
	"gap2": `PlatformLink-module__gap-2____dEB7`,
	"gap4": `PlatformLink-module__gap-4___uK2eP`,
	"gap5": `PlatformLink-module__gap-5___iyAyn`,
	"gap6": `PlatformLink-module__gap-6___hKtk7`,
	"gap8": `PlatformLink-module__gap-8___EEMMT`,
	"gap10": `PlatformLink-module__gap-10___A2YnI`,
	"gap12": `PlatformLink-module__gap-12___rTc5D`,
	"gap14": `PlatformLink-module__gap-14___VAJys`,
	"gap16": `PlatformLink-module__gap-16____zNIE`,
	"gap18": `PlatformLink-module__gap-18___s5Al1`,
	"gap20": `PlatformLink-module__gap-20___TqP9U`,
	"gap24": `PlatformLink-module__gap-24___o0R8K`,
	"gap26": `PlatformLink-module__gap-26___jkBVA`,
	"gap30": `PlatformLink-module__gap-30___iL9Bx`,
	"gap32": `PlatformLink-module__gap-32___H6fCf`,
	"gap40": `PlatformLink-module__gap-40___vbeR1`,
	"gap50": `PlatformLink-module__gap-50___NTkFz`,
	"flex1": `PlatformLink-module__flex-1___T6wOv`,
	"flexNone": `PlatformLink-module__flex-none___NFG8C`,
	"flexColumn": `PlatformLink-module__flex-column___pgbSa`,
	"flexRow": `PlatformLink-module__flex-row___GGKRy`,
	"verticallyCentered": `PlatformLink-module__vertically-centered___TL1d4`,
	"horizontallyCentered": `PlatformLink-module__horizontally-centered___QiS26`,
	"horizontallyEnd": `PlatformLink-module__horizontally-end___woCgS`,
	"verticallyStart": `PlatformLink-module__vertically-start___danm5`,
	"spaceBetween": `PlatformLink-module__space-between___MgOl3`,
	"flexWrap": `PlatformLink-module__flex-wrap___QdYoe`,
	"height100": `PlatformLink-module__height-100___m3eE_`,
	"width50": `PlatformLink-module__width-50___MZSgp`,
	"width100": `PlatformLink-module__width-100___In11X`,
	"cursorPointer": `PlatformLink-module__cursor-pointer___ScqGE`,
	"cursorNotAllowed": `PlatformLink-module__cursor-not-allowed___wZMU_`,
	"absoluteCentered": `PlatformLink-module__absolute-centered___yYi75`,
	"absolute": `PlatformLink-module__absolute___Ju20U`,
	"relative": `PlatformLink-module__relative___c1rtO`,
	"fixed": `PlatformLink-module__fixed___doNzB`,
	"visible": `PlatformLink-module__visible___JT_uu`,
	"invisible": `PlatformLink-module__invisible___CrYc9`,
	"col90": `PlatformLink-module__col-90___MwByH`,
	"colAuto": `PlatformLink-module__col-auto___vjqwC`,
	"medicalTabs": `PlatformLink-module__medical-tabs___SoYNH`,
	"medicalTableNew": `PlatformLink-module__medical-table-new___Qu7UE`,
	"noPagination": `PlatformLink-module__no-pagination___xdqwd`,
	"medicalTableEmpty": `PlatformLink-module__medical-table-empty___HmIQw`,
	"iconBtn": `PlatformLink-module__icon-btn___lguC2`,
	"searchIcon": `PlatformLink-module__search-icon___TIWXV`,
	"disableSelect": `PlatformLink-module__disable-select___XsiTi`,
	"breakWord": `PlatformLink-module__break-word___Ybyqt`,
	"popupClearBtn": `PlatformLink-module__popup-clear-btn___p1jz8`,
	"scrollMB20": `PlatformLink-module__scroll-m-b-20___xuAEZ`,
	"link": `PlatformLink-module__link___Q41xQ`,
	"disabled": `PlatformLink-module__disabled___jaSiv`,
	"badge": `PlatformLink-module__badge___bunC1`,
	"badgeText": `PlatformLink-module__badgeText___t_p7S`,
	"meta": `PlatformLink-module__meta___elKaF`,
	"title": `PlatformLink-module__title___Qwkvu`,
	"mrn": `PlatformLink-module__mrn___kUZux`,
	"arrow": `PlatformLink-module__arrow___lN9gq`,
	"line": `PlatformLink-module__line___M5lU3`,
	"menuItem": `PlatformLink-module__menuItem___NXTFo`,
	"menuItemLabel": `PlatformLink-module__menuItemLabel___hf5_m`,
	"menuItemHint": `PlatformLink-module__menuItemHint___CpSKY`
};
module.exports = ___CSS_LOADER_EXPORT___;
